import React from 'react';
import Modal from 'react-modal';

import { useAppSelector } from '../../../hooks/react-redux';
import { PageLoadingDots } from '../../shared/loading-dots/PageLoadingDots';
import { getIsResettingPassword } from '../resetPassword/store';
import styles from './Login.module.scss';
import { getIsLoggingOut } from './store';

export const LogoutOverlay: React.FC = () => {
    const isLoggingOut = useAppSelector(getIsLoggingOut);
    const resettingPassword = useAppSelector(getIsResettingPassword);

    return (
        <Modal
            ariaHideApp={false}
            isOpen={isLoggingOut && !resettingPassword}
            className={styles.logoutOverlay}
            style={{ overlay: { display: 'flex', zIndex: 100 } }}
        >
            <PageLoadingDots label='Logging out...' />;
        </Modal>
    );
};
